import { createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import {
  makeFetchSuccessActionType,
} from '../../event/fetchActionTypeProvider';
import * as AllActions from '../action';
import ActionType from '../actionType';
import { LoginState } from '../type';
const initialState: any = {
  state: LoginState.LOGOUT,
  getPassportTokenSuccess: false,
  error: '',
  userName: undefined,
  realName: undefined,
  companyName: undefined,
  companyCode: undefined,
  resourceList: [],
  roleList: [],
  user: null,
  menuButtonList: [],
  loginWay: 'passport', // passport  selfBuiltAccount 登录方式，目的:切换tab关闭checkQrCode循环
  qrCodeInfo: {
    code: 0,
    msg: '',
  },
  rolePermission: {
    roles: [],
    pagePermissions: [],
    operationPermissions: [],
  },
  organization: [],
  reload: false,
};

const loginState = createSlice({
  name: 'login',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        makeFetchSuccessActionType(ActionType.LOGIN_SMS),
        (state, action: any) => {
          const response = action.payload;
          state.state = LoginState.LOGINED;
          state.error = '';
          state.user = Object.assign({}, state.user, {
            token: response.data.accessToken,
          });
        }
      )
      .addCase(
        makeFetchSuccessActionType(ActionType.USER_INFO),
        (state, action: any) => {
          const response = action.payload;
          const {
            userName,
            roleList,
            resourceList,
            realName,
            companyName,
            companyNumber,
          } = response.data;
          state.userName = userName;
          state.realName = realName;
          state.companyName = companyName;
          state.companyCode = companyNumber;
          state.roleList = roleList;
          state.resourceList = resourceList;
          state.state = LoginState.LOGINED;
          state.user = Object.assign({}, state.user, {
            username: userName,
          });
        }
      )
      .addCase(AllActions.actionTokenInValid, (state, action: any) => {
        state.state = LoginState.LOGIN_FAILED;
        state.error = 'token验证失败！请重新登录';
        state.user = null;
      })
      .addCase(AllActions.actionLogOut, (state, action) => {
        state.error = '';
        state.user = null;
        state.state = LoginState.LOGOUT;
      })
      .addCase(AllActions.actionCheckQrCode, (state, action) => {
        if (action.payload) {
          state.qrCodeInfo = action.payload.response;
        }
      })
      .addCase(AllActions.actionChangeLoginWay, (state, action) => {
        if (action.payload) {
          state.loginWay = action.payload;
        }
      })
      .addCase(ActionType.RELOGIN, (state, action) => {
        state.user = null;
        location.replace('/login');
        message.error('登录过期，请重新登录');
      })
      .addCase(AllActions.actionReloadCookie, (state, action) => {
        state.reload = true;
      })
      .addCase(
        makeFetchSuccessActionType(ActionType.GET_PASSPORT_TOKEN),
        (state, action) => {
          state.getPassportTokenSuccess = true;
        }
      )
      .addCase(AllActions.actionSetToken, (state, action) => {
        const token = action.payload;
        state.user = Object.assign({}, state.user, {
          token,
        });
        state.state = LoginState.LOGINED;
      })
  },
});

export default loginState.reducer;
